import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import UploadFile from "./uploadRouteFile";
import { CircularProgress, Collapse } from "@material-ui/core";
import axios from "axios";
import "../styles/createNewRoute.scss";
import FrequencyRadioGroup from "./NewRouteInfo";
import { useNotification } from "../../Notifications/NotificationProvider";
import AlertDialog from "./alertDialog";
import { useHistory } from "react-router";
import AxiosClient from "../../../Network/AxiosClient";
const styleObject = { flexDirection: "column", textAlign: "center" };

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CreateNewRoute({ callBack }) {
  const [open, setOpen] = React.useState(false);
  const [agencies, setAgencies] = React.useState([]);
  const [file, setFile] = React.useState(null);
  const [routeInfo, setRouteInfo] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [alertModalData, setAlertData] = React.useState(null);

  const dispatchNotification = useNotification();
  const history = useHistory();

  React.useEffect(() => {
    getAgencies();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFile = (file) => setFile(file);
  const handleRouteInfo = (obj) => {
    setRouteInfo({ ...obj });
    //console.log(obj);
  };
  const navigateToTransfer = () => {
    history.push("/route-management/transfer");
  };

  const postNewRoute = () => {
    setLoading(true);
    setErr(null);
    const formData = new FormData();

    if (file) formData.append("file", file);
    formData.append("name", routeInfo.name ? routeInfo.name : "na");
    formData.append(
      "description",
      routeInfo.description ? routeInfo.description : ""
    );
    formData.append(
      "frequency",
      routeInfo.frequency ? routeInfo.frequency : "na"
    );
    formData.append("agency", routeInfo.agency ? routeInfo.agency : "na");

    var error = null;
    ["agency", "frequency", "name"].map((i) => {
      if (formData.get(i) === "na") {
        error = `You must fill up the ${i} field`;
        setErr(error);
        return;
      }
    });

    if (error) {
      setLoading(false);
      return;
    } else
      AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
        .then((res) => {
          setLoading(false);
          dispatchNotification({
            type: "SUCCESS",
            message: "Successfully created new route",
          });
          setAlertData({ message: "Route created successfully" });
          setRouteInfo({});
          setFile(null);
          setErr(null);
          callBack();
          setOpen(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response) {
            setErr(err.response.data.message);
            dispatchNotification({
              type: "ERROR",
              message: err.response.data.message,
            });
          } else {
            dispatchNotification({
              type: "ERROR",
              message: "Something went wrong",
            });
            setErr("Something went wrong");
          }
        });
  };

  const getAgencies = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        setAgencies(res.data.data);
        //console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="new-route-modal-container">
      <div style={{ display: "flex" }}>
        {" "}
        <button className="modal-button" onClick={handleClickOpen}>
          <AddCircleOutlineIcon className="modal-btn-icon" />
          New Route
        </button>
        <button className="transfer-button" onClick={navigateToTransfer}>
          Route transfer requests
        </button>
      </div>
      <AlertDialog
        data={alertModalData}
        callBackAlert={() => setAlertData(null)}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new route
        </DialogTitle>

        <Collapse in={err ? true : false}>
          <div className="err-msg">{err}</div>
        </Collapse>
        <DialogContent>
          <div className="route-modal-content">
            <div className="new-route-info">
              <FrequencyRadioGroup
                agencies={agencies}
                routeInfo={routeInfo}
                onChangeRouteInfo={handleRouteInfo}
              />
            </div>
            <div className="upload-area">
              <UploadFile
                heading={"New route"}
                api={""}
                help={"please uplaod csv file"}
                styles={styleObject}
                onChangeFile={handleFile}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button onClick={postNewRoute} className="create-button">
            {loading && (
              <CircularProgress
                color={"#e2136e"}
                size={12}
                style={{ marginRight: 10 }}
              />
            )}
            {loading ? "Creating" : "Create"}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
